import { login, logout, } from '@/api/interface'
import { getToken, setToken, removeToken } from '../../utils/token'
import { Message } from 'element-ui'
import { getLanguage, setLanguage } from '@/i18n/langs/index'
import Cookies from 'js-cookie';
import i18n from '../../i18n/langs';

const state = {
    token: getToken(),
    roles: JSON.parse(localStorage.getItem('userInfo')) || {},
    language: getLanguage()
}

const mutations = {
    SET_TOKEN: (state, token) => {
        state.token = token
    },
    SET_ROLES: (state, roles) => {
        state.roles = roles
    },
    SET_LANGUAGE: (state, language) => {
        state.language = language
        Cookies.set('language', language)
    },

}

const actions = {
    Login({ commit }, userInfo) {
        const account = userInfo.username.trim()
        return new Promise((resolve, reject) => {
            login(account, userInfo.password).then(response => {
                if (response.code == 200) {
                    console.log(response, 90000000)
                    setToken(response.data.token)
                    commit('SET_TOKEN', response.data.token)
                    localStorage.setItem('userInfo',
                        JSON.stringify({
                            roleId: response.data.roleId,
                            name: response.data.phone,
                            userId: response.data.id,
                        }))
                    commit('SET_ROLES', {
                        roleId: response.data.roleId,
                        name: response.data.phone,
                        userId: response.data.id,
                    })

                } else {
                    Message({
                        message: response.msg,
                        type: 'error',
                        duration: 3 * 1000
                    })
                }
                resolve()
            }).catch(error => {
                reject(error)
            })
        })
    },

    LogOut({ commit, state }) {
        return new Promise((resolve, reject) => {

            logout().then((response) => {
                console.log(response)
                commit('SET_TOKEN', '')
                commit('SET_ROLES', {})
                localStorage.removeItem('userName')
                removeToken()
                resolve()
            }).catch(error => {
                reject(error)
            })
        })
    }
    ,

    FedLogOut({ commit }) {
        return new Promise(resolve => {
            console.log('登出操作')
            commit('SET_TOKEN', '')
            commit('SET_ROLES', {})
            localStorage.removeItem('userName')
            removeToken()
            resolve()
        })
    },
    setLanguage({ commit }, language) {
        setLanguage(language);
        commit('SET_LANGUAGE', language)
        let titleDom = document.getElementById('title-dom');
        titleDom.innerHTML = i18n.t('title.dev_assistant_platform');
    },
}
export default {
    namespaced: true,
    state,
    mutations,
    actions
}
